import { Utils } from "@crispico/foundation-react";
import { IActionParam } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";
import { CreateMissionAction } from "actions/CreateMissionAction";
import moment from "moment-timezone";

export class CreateMissionForProposedTimeSlotAction extends CreateMissionAction {

    label = (param: IActionParam) => {
        const entity = this.props.getEntityAt(param.selection[0]);
        const name = entity ? (entity.type?.name || entity.inactivityType?.name) : undefined;
        if (name) {
            return _msg("CreateMissionActionWithParam.label", name);
        }
        return _msg("CreateMissionAction.label");
    }

    protected getSearchParams(id: string | number, _: string): string {
        const entity = this.props.getEntityAt(id);
        if (!entity) {
            return '';
        }
        const params = new URLSearchParams();
        params.set(`startTime`, moment(entity.startTime).toISOString());
        params.set(`endTime`, moment(entity.endTime).toISOString());
        let color = entity.type?.color || entity.inactivityType?.color;
        // The `color` field in `mission` is an integer, but in `missionType` it's a string.
        // This means we need to convert the hex string to an integer.
        color = typeof color === "string" ? Utils.convertColorFromHex(color) : color;
        params.set(`color`, color);
        let resourceField = 'equipmentResource';
        if (entity.resource) {
            resourceField = entity.resource.__typename.charAt(0).toLowerCase() + entity.resource.__typename.slice(1);
        }
        params.set(resourceField, JSON.stringify(entity.resource));
        params.set(`inactivityType`, JSON.stringify(entity.inactivityType));
        params.set(`type`, JSON.stringify({ id: entity.type?.id, name: entity.type?.name }));
        params.set(`equipmentType`, JSON.stringify(entity.equipmentType));

        return params.toString();
    }

    isVisible(param: IActionParam) {
        return param.selection.length === 1 && this.getEntityName(param.selection[0]) === "ProposedTimeSlot";
    }
}
